<template>
  <div>
    <FloatButton @openChat="toggleModal()" v-if="!isOpen && hasPermission" />
    <ChatModal v-if="isOpen" :open="isOpen" @closeChat="toggleModal()" />
  </div>
</template>


<script>
import { mapActions } from 'vuex'
export default {
  props: {
  },
  async created () {
    const token = localStorage.getItem('access-token')
    if (token) {
      await this.getPermissionLocal()
    }

    this.$watchLocalStorage('access-token', (token) => {
      if (token) this.getPermissionLocal()
      else this.hasPermission = false
    })
  },
  data () {
    return {
      isOpen: false,
      hasPermission: false,
    }
  },
  methods: {
    ...mapActions({
      getPermission: 'agent/getPermission'
    }),
    toggleModal () {
      this.isOpen = !this.isOpen
    },
    async getPermissionLocal () {
      const resp = await this.getPermission()
      if (resp?.response?.hasPermission) this.hasPermission = true
      return false
    },
  },
  components: {
    FloatButton: () => import('@/components/FloatButton.vue'),
    ChatModal: () => import('@/components/ChatModal.vue'),
  }
}
</script>
